import { render } from "./MediaBar.vue?vue&type=template&id=488d2f2c&ts=true"
import script from "./MediaBar.vue?vue&type=script&lang=ts"
export * from "./MediaBar.vue?vue&type=script&lang=ts"

import exportComponent from "/workspaces/hackerspace-lelab.github.io/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__